import { getToken } from "./utils";

const API_URL = (process.env.REACT_APP_API_URL || "http://localhost:8000") + "/admin/templates";

async function buildApiError(response, fallbackMessage) {
  let message = fallbackMessage;

  try {
    const payload = await response.json();
    const detail = payload?.detail ?? payload?.message ?? payload;
    message = typeof detail === "string" ? detail : JSON.stringify(detail);
  } catch (_error) {
    try {
      const text = await response.text();
      if (text) {
        message = text;
      }
    } catch (_textError) {
      // Keep the fallback message.
    }
  }

  return new Error(message);
}

export async function generateAiTemplatePlan(form) {
  const response = await fetch(`${API_URL}/ai-plan`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(form),
  });

  if (!response.ok) {
    throw await buildApiError(response, "Failed to generate AI template plan");
  }

  return response.json();
}

export async function generateAiCompositionPlan(form) {
  const response = await fetch(`${API_URL}/ai-composition-plan`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(form),
  });

  if (!response.ok) {
    throw await buildApiError(response, "Failed to generate AI composition plan");
  }

  return response.json();
}

export async function refineAiCompositionPlan(payload) {
  const response = await fetch(`${API_URL}/ai-composition-plan/refine`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw await buildApiError(response, "Failed to refine AI composition plan");
  }

  return response.json();
}
